import administration from 'translations/en/administration'
import auth from 'translations/en/auth'
import employee from 'translations/en/employee'
import forms from 'translations/en/forms'
import components from 'translations/en/components'
import manager from 'translations/en/manager'
import onboarding from 'translations/en/onboarding'
import punch from 'translations/en/punch'
import searchBar from 'translations/en/searchBar'
import chat from 'translations/en/chat'
import titles from 'translations/en/titles'
import upload from 'translations/en/upload'

export default {
  ATTACHMENTS: {
    WARNING: 'Files can only be attached to existing shifts.'
  },
  // Do not delete this, used for tests
  TRANSLATION_TEST: `Test translation`,
  TRANSLATION_TEST_CARD: {
    TITLE: `Test card title`,
    SUMMARY: `Test card summary`
  },
  USERNAME_PASSWORD_INVALID: `Username or password invalid`,
  USER_ARCHIVED: `Your account is archived`,
  ATTEMPT_LIMIT_REACH: `Attempt limit reached`,
  EMAIL_DESCRIPTION: ``,
  EMAIL_PLACEHOLDER: `Enter your email`,
  MUST_BE_A_VALID_EMAIL: `Invalid email`,
  VALIDATION_ERROR: `Validation error`,
  DATE_RANGE_MISSING: `Please select a start date and an end date`,
  RELEASES: `Versions`,
  TRUE: `True`,
  FALSE: `False`,
  actions: {
    SAVE: 'Save',
    EDIT: 'Edit',
    CONFIRM: 'Confirm',
    CANCEL: 'Cancel',
    DELETE: 'Delete',
    ARCHIVE: 'Archive',
    ACCEPT: `Accept`,
    VIEW: `View`,
    BACK: `Back`,
    DUPLICATE: `Duplicate`,
    SUBMIT: `Submit`,
    ADD: `Add`,
    CLOSE: `Close`,
    REMOVE: `Remove`,
    SEND: `Send`,
    APPLY: `Apply`,
    COPY: `Copy`,
    APPROVE: `Approve`,
    UNAPPROVE: `Unapprove`
  },
  push: {
    HOW_TO_ENABLE: `How do I enable them?`,
    PUSH_ARE_NOT_ALLOWED: `Push notifications are off`,
    WHY_PUSH: `Enable push notifications to be alerted when an request you submitted changes status, your employer sends an important message and when you have shift offers available.`
  },
  SELECTION_OPTIONS: {
    SELECTED_COUNT: `{{ count }} selected`,
    SELECTED_COUNT_other: `{{ count }} selected`,
    SELECT_ALL: `Select all`,
    CLEAR_SELECTION: `Clear selection`
  },
  ALL_DAY: `All day`,
  NO_APP_ACCESS: `You do not have access to any application module.`,
  NEW_VERSION_TITLE: `New version availabile`,
  NEW_VERSION_DESCRIPTION: `There is a new version available. You can click here to refresh the application and implement the changes.`,
  REFRESH: `Refresh`,
  'HOME-CALL': `Phone Call`,
  'MOBILE-CALL': `Call and Text`,
  'MOBILE-SMS': `Text Message`,
  'DO-NOT-USE': `Do not Use`,
  WORK: `Work`,
  PERSONEL: `Personal`,
  SUBMIT: `Submit`,
  NEXT: `Next`,
  PREVIOUS: `Previous`,
  CANCEL: `Cancel`,
  HELP_CENTER: `Help Center`,
  IMPORTANT_INFORMATION: `Important information`,
  CONTACT_SUPPORT: `Contact support`,
  HELP_VIDEOS: `Video tutorials`,
  WHATS_NEW: `What's new ?`,
  STARTS_ON: `Starts on`,
  ENDS_ON: `Ends on`,
  APPLICATION_ERROR: `Application error`,
  APPLICATION_ERROR_DESC: `An application error has occurred, please try again. If the error persists, contact your manager.`,
  SOMETHING_WENT_WRONG: `Something went wrong.`,
  NO_DATA: `No data`,
  TO: 'to',
  DATE_RANGE: `to`,
  INVALID_TOKEN: `The link used is either invalid or expired.`,
  manageEmployee: { PASSWORD_REQUIREMENT: `The password doen't meet the company security standard.` },
  LOADING: `Loading`,
  LEAVE: `Leave`,
  NO_INTERNET_ACCESS: `You do not have access to the Internet.`,
  WILL_RESUME_WHEN_INTERNET_AVAILABLE: `The app access will resume when you are connected again.`,
  THIS_RESOURCE_DOESNT_EXIST_OR_HAS_BEEN_DELETED: `This resource doesn't exist or has been deleted.`,
  INVALID_EMAIL: `Invalid email`,
  NAME: `Name`,
  DATE: `Date`,
  NAME_FR: `French name`,
  NAME_EN: `English name`,
  EXPORT_CODE: `Export code`,
  EXPORT_PDF: `Export PDF`,
  IMPORT_CODE: `Import code`,
  EARNING_CODE: `Earning code`,
  ARCHIVE: `Archive`,
  UNARCHIVE: `Unarchive`,
  DELETE: `Delete`,
  EDIT: `Edit`,
  errors: {
    BAD_PASSWORD: {
      TITLE: `Bad password`,
      DESCRIPTION: `The entered password is invalid. Please try again.`
    },
    BAD_USERNAME_CONFIRMATION: {
      TITLE: `Wrong username`,
      DESCRIPTION: `The username that you entered did not match your username.`
    }
  },
  OPTIONS: `Options`,
  VIEW: `View`,
  EXPORT: `Export`,
  NO_SORT: `No sort`,
  NO_FILTER: `No filter`,
  NO_CONFIG: `No config`,
  NO_PROCEDURE: `No procedure`,
  DESCRIPTION: `Description`,
  CLOSE: `Close`,
  SELECT: `Select`,
  SELECTED: `Selected`,
  SAVE: `Save`,
  COLOR: 'Color',
  APPLY: `Apply`,
  NA: `N/A`,
  ROW_DATA_ERROR: `Something prevents use from displaying the information contained in this row.`,
  ROW_DATA_ERROR_ID: `Data unique ID is: {{_id}}`,
  PUSH_ERROR: `An error occured while registering for push notifications.`,
  // TRANSLATIONS FOR THE APP SETTINGS ARRAY VALUE
  APPROVAL_REQUIRED: `Approval required`,
  CHANGES_REQUESTED: `Changes requested`,
  ACKNOWLEDGE: `Acknowledge`,
  JUSTIFIED: `Justified`,
  UNJUSTIFIED: `Unjustified`,
  IN_PROGRESS: `In progress`,
  ACKNOWLEDGED: `Acknowledged`,
  APPROVED: `Approved`,
  APPROVE: `Approve`,
  REFUSED: `Refused`,
  CANCELLED: `Cancelled`,
  firstName: `First name`,
  lastName: `Last name`,
  employeeNumber: `Employee number`,
  SUNDAY: `Sunday`,
  MONDAY: `Monday`,
  TUESDAY: `Tuesday`,
  WEDNESDAY: `Wednesday`,
  THURSDAY: `Thursday`,
  FRIDAY: `Friday`,
  SATURDAY: `Saturday`,
  FINALIZED: `Finalized`,
  COMMENT: `Comment`,
  '1MONTH': `1 month`,
  '2MONTH': `2 month`,
  EN: `English`,
  FR: `French`,
  NETHRIS_EMPLOYEURD: `Nethris/EmployeurD`,
  APOGEE: `Apogée`,
  GENERIC: `Generic`,
  CLEAR: `Clear`,
  SUBMIT_AND_CREATE_OTHER: `Submit and create another`,
  SEARCH: `Search`,
  SETTINGS: `Settings`,
  EMPLOYEE: `Employee`,
  administration,
  auth,
  employee,
  forms,
  components,
  manager,
  onboarding,
  punch,
  searchBar,
  chat,
  titles,
  upload
}
